import { BaseModel } from 'core/models/base.model.js';
import { STR } from 'utils/str.js';

/**
 * Model of SearchResultatsListeCpt
 */
export var SearchResultatsListeCptModel = BaseModel.extend({

  defaults: {
    "libelle": "",
    "valeur": "",
    "type": ""
  },

  parse: function(response) {
    if (response && STR.isBlank(response.id) && !STR.isBlank(response.code)) {
      response.id = response.code;
    }
    return response;
  }
});
